import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@node_modules/@angular/router';
import * as moment from 'moment';
import { DateTime } from 'luxon';
import { CommonLookupServiceProxy, DropDownLookupDto, FindProductOutputDto, GeneralLedgerOutputDto, GetAccountJournalInput, GetProductInput, InventoryMovementReportListDto, InventoryReportServiceProxy, ProductListDto, TransactionType } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '../../../../shared/common/app-component-base';
import { UtilsService } from '../../../shared/common/utils/utils-service';

@Component({
  selector: 'app-inventory-movement',
  standalone: false,
  
  templateUrl: './inventory-movement.component.html',
  styles: ``
})
export class InventoryMovementComponent extends AppComponentBase {
    loading = false;
    locations: DropDownLookupDto[] = [];
    productSelectedItem: FindProductOutputDto;
    // Selection Models
    selectedLocations: any[] = [];
    // Date Range
    dateRange: Date[] = [];
    module = TransactionType;
    // Results
    products: InventoryMovementReportListDto[] = [];

    constructor(
        injector: Injector,
        private inventoryReportService: InventoryReportServiceProxy,
        private commonLookupService: CommonLookupServiceProxy,
        private route: ActivatedRoute,
        public utilsService: UtilsService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        
        this.initializeDateRange();
        this.loadLocations();
        /*this.loadFromRouteParams();*/
    }

    initializeDateRange() {
        const today = new Date();
        this.dateRange = [today, today];

    }

    loadLocations() {
        this.commonLookupService.getAllLocationForTableDropdown()
            .subscribe(result => {
                this.locations = result;
                debugger;
                const defaultLoc = this.locations.find(l => l.id === this.appSession.user.locationId);
                if (defaultLoc) {
                    this.selectedLocations = [defaultLoc];
                }
            });
    }

    loadFromRouteParams() {
        this.route.queryParams.subscribe(params => {
            if (params['startDate']) {
                this.dateRange[0] = new Date(params['startDate']);
            }
            if (params['endDate']) {
                this.dateRange[1] = new Date(params['endDate']);
            }
            if (params['locations']) {
                const ids = params['locations'].split('-').map((x: string) => Number(x));
                this.selectedLocations = this.locations.filter(l => ids.includes(l.id));
            }
            //if (params['accountId']) {
            //    const acc = this.accounts.find(a => a.value === params['accountId']);
            //    if (acc) {
            //        this.selectedAccounts = [acc];
            //    }
            //}
            setTimeout(() => {
                this.getDetails();
            }, 5000);

        });
    }

    setDateRange(type: string) {
        const today = new Date();
        let start: Date, end: Date;

        switch (type) {
            case 'today':
                start = end = today;
                break;
            case '7days':
                start = new Date();
                start.setDate(today.getDate() - 6);
                end = today;
                break;
            case '30days':
                start = new Date();
                start.setDate(today.getDate() - 29);
                end = today;
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'lastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            default:
                start = end = today;
        }

        this.dateRange = [start, end];
    }


    getDetails() {
       

        if (!this.dateRange || this.dateRange.length < 2) {
            return;
        }

        if (this.productSelectedItem == null) {
            abp.notify.error(this.l('PleaseSelectProduct'));
        }

        this.primengTableHelper.showLoadingIndicator();
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
        const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;

        this.loading = true;

        const input = new GetProductInput();
        input.locationId = 0;
        input.products = [];
        var product = new ProductListDto();
        product.productId = this.productSelectedItem.id;
        product.productName = this.productSelectedItem.displayName;
        product.productCode = this.productSelectedItem.code;
        input.products.push(product);

        input.startDate = startDate ? DateTime.fromISO(startDate) : undefined;
        input.endDate = endDate ? DateTime.fromISO(endDate) : undefined;
        input.locations = locations;
        console.log(input);
        this.inventoryReportService
            .getInventoryMovement(input)
            .subscribe(result => {
                this.products = result;
               
            });
    }

    clear() {
        this.productSelectedItem = null;
    }

    getProduct(product: FindProductOutputDto) {
        this.productSelectedItem = product;
    }

    exportExcel() {
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

        const locations = this.selectedLocations.length ? this.selectedLocations : this.locations;

        this.loading = true;

        const input = new GetAccountJournalInput();
        input.locationId = 0;
        input.accountId = 0;
        input.defaultLocationId = abp.session.userId;

        input.startDate = startDate ? DateTime.fromISO(startDate) : undefined;
        input.endDate = endDate ? DateTime.fromISO(endDate) : undefined;

        input.locations = locations;

        input.transactionNo = null;
        input.customerVendorId = 0;
        input.journalNo = null;
        input.isAuto = false;
        input.defaultPeriod = 0;

        input.sorting = '';
        input.maxResultCount = 999;
        input.skipCount = 0;

        //this.AccountJournalReportServiceProxy.getGeneralLedger(input).subscribe(result => {
        //    /* abp.downloadTempFile(result);*/
        //    this.loading = false;
        //});
    }
}
